import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngRowState extends ngCellEx
{
	constructor () {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {
		this.shadowRoot.innerHTML = ``;

		super.connectedCallback();
		
		this.cell.dataset.bind = "rowState";
	};
	
	dataRefresh = (v) => {
		//var tr = $(this.cell).closest("tr");
		//var row = parseInt(this.cell.dataset.row);
		
		switch (this.data.__ng.rowState) {
		case ninegrid.ROW_STATE.INSERT:
			ninegrid.j.querySelectorAll(this).addClass('added').removeClass('updated');
			break;
		case ninegrid.ROW_STATE.UPDATE:
			ninegrid.j.querySelectorAll(this).addClass('updated');
			break;
		default:
			ninegrid.j.querySelectorAll(this).removeClass('added').removeClass('updated');
			break;
		}
		
		if (!v) this.reset();
	};
}

if (!customElements.get('ng-row-state')) {
	customElements.define("ng-row-state", ngRowState);
}
